import { createElementBlock, createElementVNode, openBlock } from "vue";
//#region src/library/icons/interface-bookmark.svg
var _hoisted_1 = {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "currentColor",
	viewBox: "0 0 256 256"
};
function render(_ctx, _cache) {
	return openBlock(), createElementBlock("svg", _hoisted_1, [..._cache[0] || (_cache[0] = [createElementVNode("path", { d: "M184 32H72a16 16 0 0 0-16 16v176a8 8 0 0 0 12.24 6.78L128 193.43l59.77 37.35A8 8 0 0 0 200 224V48a16 16 0 0 0-16-16m0 177.57-51.77-32.35a8 8 0 0 0-8.48 0L72 209.57V48h112Z" }, null, -1)])]);
}
var interface_bookmark_default = { render };
//#endregion
export { interface_bookmark_default as default, render };

//# sourceMappingURL=interface-bookmark.svg.js.map